import type { Apu } from './tipos'
import { recalcularApu } from './tipos'

export const APUS_INICIALES: Apu[] = [
  recalcularApu({
    id: 'apu-spt-01',
    codigo: 'APU-SPT-01',
    nombre: 'SUMINISTRO E INSTALACIÓN DE VARILLA CU-CU 5/8 X 2.40 M INCLUYE TUBERÍA Y CAJA DE INSPECCIÓN',
    descripcion: 'Sistema de puesta a tierra con varilla cooperweld, soldadura exotérmica 115g, tubería bajante y caja de inspección 30x30 cm.',
    unidad: 'UND',
    categoria: 'Puesta a Tierra',
    equipos: [
      { id: 'eq-1', descripcion: 'Caja de herramientas menores', unidad: 'EQU', tarifa: 16693.75, rendimiento: 0.79, valor_unitario: 13208.94 }
    ],
    materiales: [
      { id: 'mat-1', codigo: 'VAR-58', descripcion: 'Varilla Cooperweld 5/8 x 2.4 m', unidad: 'UND', costo_base: 312147.83, factor_margen_pct: 15, costo_unitario: 358970.00, cantidad: 1, valor_parcial: 358970.00 },
      { id: 'mat-2', codigo: 'SOL-115', descripcion: 'Soldadura exotérmica 115g', unidad: 'UND', costo_base: 30608.70, factor_margen_pct: 15, costo_unitario: 35200.00, cantidad: 1, valor_parcial: 35200.00 },
      { id: 'mat-3', codigo: 'TUB-IMC-12', descripcion: 'Tubo IMC de 1/2 pulgada x 3 m', unidad: 'UND', costo_base: 17391.30, factor_margen_pct: 15, costo_unitario: 20000.00, cantidad: 1, valor_parcial: 20000.00 },
      { id: 'mat-4', codigo: 'CAB-08-V', descripcion: 'Cable Cu aislado No 8 AWG verde', unidad: 'M', costo_base: 7652.17, factor_margen_pct: 15, costo_unitario: 8800.00, cantidad: 3, valor_parcial: 26400.00 },
      { id: 'mat-5', codigo: 'ACC-VARIOS', descripcion: 'Curva PVC, adaptadores campana y terminal IMC', unidad: 'KIT', costo_base: 5913.04, factor_margen_pct: 15, costo_unitario: 6800.00, cantidad: 1, valor_parcial: 6800.00 }
    ],
    transportes: [
      { id: 'tr-1', descripcion: 'Camioneta 4x4 acarreo y cuadrilla', volumen_o_peso: 1, rendimiento: 0.01, costo_tarifa: 130500, valor_parcial: 1305.00 }
    ],
    mano_obra: [
      { id: 'mo-1', cargo: 'Oficial de Obra Civil', salario_base: 184558.40, costo_dia: 184558.40, rendimiento: 0.40, horas_hombre: 3.20, costo_total: 73823.36 },
      { id: 'mo-2', cargo: 'Ayudante de Electricista', salario_base: 116532.00, costo_dia: 116532.00, rendimiento: 0.50, horas_hombre: 4.00, costo_total: 58266.00 }
    ],
    aiu: {
      porcentaje_admin: 10.00,
      porcentaje_imprevistos: 0.00,
      porcentaje_utilidad: 3.00,
      porcentaje_iva_utilidad: 19.00
    },
    activo: true,
    created_at: new Date().toISOString(),
  }),
  recalcularApu({
    id: 'apu-con-01',
    codigo: 'APU-CON-01',
    nombre: 'SUMINISTRO E INSTALACIÓN DE CABLE DE COBRE 2/0 AWG DESNUDO',
    descripcion: 'Conductor de cobre desnudo 2/0 AWG para malla de puesta a tierra o bajante de apantallamiento con terminales.',
    unidad: 'ML',
    categoria: 'Conductores',
    equipos: [
      { id: 'eq-1', descripcion: 'Caja de herramientas menores', unidad: 'EQU', tarifa: 16693.75, rendimiento: 0.10, valor_unitario: 1753.65 }
    ],
    materiales: [
      { id: 'mat-1', codigo: 'CAB-20-CU', descripcion: 'Cable de cobre desnudo 2/0 AWG 7 hilos', unidad: 'M', costo_base: 51428.94, factor_margen_pct: 15, costo_unitario: 59143.29, cantidad: 1, valor_parcial: 59143.29 },
      { id: 'mat-2', codigo: 'BOR-20', descripcion: 'Bornera estañada de cobre 2/0 AWG', unidad: 'UND', costo_base: 8542.43, factor_margen_pct: 15, costo_unitario: 9823.80, cantidad: 0.016, valor_parcial: 158.45 },
      { id: 'mat-3', codigo: 'TUB-EMT-1', descripcion: 'Tubo EMT 1 pulgada accesorio', unidad: 'M', costo_base: 32252.05, factor_margen_pct: 15, costo_unitario: 37089.86, cantidad: 0.004, valor_parcial: 149.56 }
    ],
    transportes: [
      { id: 'tr-1', descripcion: 'Camioneta 4x4', volumen_o_peso: 1, rendimiento: 0.004, costo_tarifa: 50000, valor_parcial: 200.00 }
    ],
    mano_obra: [
      { id: 'mo-1', cargo: 'Técnico Electricista', salario_base: 184558.40, costo_dia: 184558.40, rendimiento: 0.055, horas_hombre: 0.44, costo_total: 10253.24 },
      { id: 'mo-2', cargo: 'Ayudante de Electricista', salario_base: 116532.00, costo_dia: 116532.00, rendimiento: 0.062, horas_hombre: 0.50, costo_total: 7283.25 }
    ],
    aiu: {
      porcentaje_admin: 10.00,
      porcentaje_imprevistos: 0.00,
      porcentaje_utilidad: 3.00,
      porcentaje_iva_utilidad: 19.00
    },
    activo: true,
    created_at: new Date().toISOString(),
  }),
  recalcularApu({
    id: 'apu-can-01',
    codigo: 'APU-CAN-01',
    nombre: 'SUMINISTRO E INSTALACIÓN DE TUBERÍA EMT 3/4" INCLUYE ACCESORIOS DE FIJACIÓN Y SOPORTERÍA',
    descripcion: 'Canalización superficial o adosada con tubería conduit EMT de 3/4 pulgada, uniones, terminales, abrazaderas y riel unistrut.',
    unidad: 'ML',
    categoria: 'Canalizaciones',
    equipos: [
      { id: 'eq-1', descripcion: 'Caja de herramientas y doblatubo', unidad: 'EQU', tarifa: 16693.75, rendimiento: 0.09, valor_unitario: 1505.45 }
    ],
    materiales: [
      { id: 'mat-1', codigo: 'TUB-EMT-34', descripcion: 'Tubo metálico EMT 3/4 pulgada x 3 m', unidad: 'M', costo_base: 11392.90, factor_margen_pct: 15, costo_unitario: 13101.84, cantidad: 1, valor_parcial: 13101.84 },
      { id: 'mat-2', codigo: 'UNI-EMT-34', descripcion: 'Unión EMT 3/4 pulgada', unidad: 'UND', costo_base: 1917.99, factor_margen_pct: 15, costo_unitario: 2205.70, cantidad: 1, valor_parcial: 2205.70 },
      { id: 'mat-3', codigo: 'TER-EMT-34', descripcion: 'Terminal EMT 3/4 pulgada', unidad: 'UND', costo_base: 2813.06, factor_margen_pct: 15, costo_unitario: 3235.02, cantidad: 1, valor_parcial: 3235.02 },
      { id: 'mat-4', codigo: 'RIE-2X4', descripcion: 'Riel Chanel perforado 2x4 cm soporte', unidad: 'M', costo_base: 13212.87, factor_margen_pct: 15, costo_unitario: 15194.80, cantidad: 0.33, valor_parcial: 15194.80 },
      { id: 'mat-5', codigo: 'ABR-INE-34', descripcion: 'Abrazadera inestruck 3/4 y chazos', unidad: 'KIT', costo_base: 2371.72, factor_margen_pct: 15, costo_unitario: 2727.47, cantidad: 1, valor_parcial: 2727.47 }
    ],
    transportes: [
      { id: 'tr-1', descripcion: 'Camioneta 4x4', volumen_o_peso: 1, rendimiento: 0.01, costo_tarifa: 130500, valor_parcial: 1305.00 }
    ],
    mano_obra: [
      { id: 'mo-1', cargo: 'Técnico Electricista', salario_base: 184558.40, costo_dia: 184558.40, rendimiento: 0.05, horas_hombre: 0.40, costo_total: 9227.92 },
      { id: 'mo-2', cargo: 'Ayudante de Electricista', salario_base: 116532.00, costo_dia: 116532.00, rendimiento: 0.05, horas_hombre: 0.40, costo_total: 5826.60 }
    ],
    aiu: {
      porcentaje_admin: 10.00,
      porcentaje_imprevistos: 0.00,
      porcentaje_utilidad: 3.00,
      porcentaje_iva_utilidad: 19.00
    },
    activo: true,
    created_at: new Date().toISOString(),
  }),
  recalcularApu({
    id: 'apu-ilu-01',
    codigo: 'APU-ILU-01',
    nombre: 'SALIDA PARA ILUMINACIÓN EN TUBERÍA EMT 1/2" PARA LÁMPARA HERMÉTICA LED 2X25W',
    descripcion: 'Salida completa con caja de conexión 4x4, conectores resorte, tubería EMT 1/2", cableado y luminaria LED hermética IP65.',
    unidad: 'UND',
    categoria: 'Luminarias',
    equipos: [
      { id: 'eq-1', descripcion: 'Caja de herramientas y escalera', unidad: 'EQU', tarifa: 25000.00, rendimiento: 0.20, valor_unitario: 5018.17 }
    ],
    materiales: [
      { id: 'mat-1', codigo: 'LUM-HER-225', descripcion: 'Luminaria LED hermética 2x25W IP65 industrial', unidad: 'UND', costo_base: 192313.04, factor_margen_pct: 15, costo_unitario: 221160.00, cantidad: 1, valor_parcial: 221160.00 },
      { id: 'mat-2', codigo: 'CAJ-EMT-44', descripcion: 'Caja EMT 4x4 5 salidas 1/2 pulgada', unidad: 'UND', costo_base: 11478.26, factor_margen_pct: 15, costo_unitario: 13200.00, cantidad: 1, valor_parcial: 13200.00 },
      { id: 'mat-3', codigo: 'ACC-CON-RES', descripcion: 'Conectores resorte, cinta Scotch 33 y adaptadores', unidad: 'KIT', costo_base: 9969.13, factor_margen_pct: 15, costo_unitario: 11464.50, cantidad: 1, valor_parcial: 11464.50 }
    ],
    transportes: [
      { id: 'tr-1', descripcion: 'Camioneta 4x4', volumen_o_peso: 1, rendimiento: 0.01, costo_tarifa: 130500, valor_parcial: 1305.00 }
    ],
    mano_obra: [
      { id: 'mo-1', cargo: 'Oficial de Obra Civil / Electricista', salario_base: 184558.40, costo_dia: 184558.40, rendimiento: 0.166, horas_hombre: 1.33, costo_total: 30759.73 },
      { id: 'mo-2', cargo: 'Ayudante de Electricista', salario_base: 116532.00, costo_dia: 116532.00, rendimiento: 0.166, horas_hombre: 1.33, costo_total: 19422.00 }
    ],
    aiu: {
      porcentaje_admin: 10.00,
      porcentaje_imprevistos: 0.00,
      porcentaje_utilidad: 3.00,
      porcentaje_iva_utilidad: 19.00
    },
    activo: true,
    created_at: new Date().toISOString(),
  }),
  recalcularApu({
    id: 'apu-sal-01',
    codigo: 'APU-SAL-01',
    nombre: 'SALIDA PARA TOMACORRIENTE 110V DOBLE CON POLO A TIERRA EN TUBERÍA EMT 1/2"',
    descripcion: 'Salida eléctrica en tubería EMT 1/2", caja de sobreponer 2x4", tomacorriente doble de 10A y conectores de empalme.',
    unidad: 'UND',
    categoria: 'Salidas Eléctricas',
    equipos: [
      { id: 'eq-1', descripcion: 'Caja de herramientas menores', unidad: 'EQU', tarifa: 16693.75, rendimiento: 0.22, valor_unitario: 3763.63 }
    ],
    materiales: [
      { id: 'mat-1', codigo: 'TOM-DOB-10', descripcion: 'Tomacorriente doble polo a tierra 10A 110V', unidad: 'UND', costo_base: 15478.26, factor_margen_pct: 15, costo_unitario: 17800.00, cantidad: 1, valor_parcial: 17800.00 },
      { id: 'mat-2', codigo: 'CAJ-EMT-24', descripcion: 'Caja EMT 2x4 de sobreponer', unidad: 'UND', costo_base: 11478.26, factor_margen_pct: 15, costo_unitario: 13200.00, cantidad: 1, valor_parcial: 13200.00 },
      { id: 'mat-3', codigo: 'ACC-CON-TER', descripcion: 'Conector resorte, cinta Scotch 33 y adaptador', unidad: 'KIT', costo_base: 9969.13, factor_margen_pct: 15, costo_unitario: 11464.50, cantidad: 1, valor_parcial: 11464.50 }
    ],
    transportes: [
      { id: 'tr-1', descripcion: 'Camioneta 4x4', volumen_o_peso: 1, rendimiento: 0.01, costo_tarifa: 130500, valor_parcial: 1305.00 }
    ],
    mano_obra: [
      { id: 'mo-1', cargo: 'Técnico Electricista', salario_base: 184558.40, costo_dia: 184558.40, rendimiento: 0.125, horas_hombre: 1.00, costo_total: 23069.80 },
      { id: 'mo-2', cargo: 'Ayudante de Electricista', salario_base: 116532.00, costo_dia: 116532.00, rendimiento: 0.125, horas_hombre: 1.00, costo_total: 14566.50 }
    ],
    aiu: {
      porcentaje_admin: 10.00,
      porcentaje_imprevistos: 0.00,
      porcentaje_utilidad: 3.00,
      porcentaje_iva_utilidad: 19.00
    },
    activo: true,
    created_at: new Date().toISOString(),
  }),
  recalcularApu({
    id: 'apu-alu-01',
    codigo: 'APU-ALU-01',
    nombre: 'SUMINISTRO E INSTALACIÓN DE LUMINARIA LED 27.8W ALUMBRADO PÚBLICO IP66 IK08',
    descripcion: 'Luminaria vial y alumbrado público LED 27.8W, eficiencia >130 lm/W, base fotocelda 7 pines, brazo galvanizado en poste y conexión a red trenzada.',
    unidad: 'UND',
    categoria: 'Alumbrado Público',
    equipos: [
      { id: 'eq-1', descripcion: 'Caja de herramientas liniero', unidad: 'EQU', tarifa: 16693.75, rendimiento: 0.25, valor_unitario: 4173.44 },
      { id: 'eq-2', descripcion: 'Grúa con canasta aislada (hora)', unidad: 'HORA', tarifa: 150000.00, rendimiento: 0.33, valor_unitario: 49500.00 }
    ],
    materiales: [
      { id: 'mat-1', codigo: 'LUM-ALU-27', descripcion: 'Luminaria LED 27.8W alumbrado público 5000K', unidad: 'UND', costo_base: 243478.26, factor_margen_pct: 15, costo_unitario: 280000.00, cantidad: 1, valor_parcial: 280000.00 },
      { id: 'mat-2', codigo: 'FOT-7PIN', descripcion: 'Fotocontrol electrónico 105-305V 7 pines', unidad: 'UND', costo_base: 39130.43, factor_margen_pct: 15, costo_unitario: 45000.00, cantidad: 1, valor_parcial: 45000.00 },
      { id: 'mat-3', codigo: 'BRA-GALV-15', descripcion: 'Brazo metálico galvanizado en caliente 1.5 m', unidad: 'UND', costo_base: 47826.09, factor_margen_pct: 15, costo_unitario: 55000.00, cantidad: 1, valor_parcial: 55000.00 },
      { id: 'mat-4', codigo: 'CBL-CON-14', descripcion: 'Cable encauchetado 3x14 y conectores perforación', unidad: 'KIT', costo_base: 15652.17, factor_margen_pct: 15, costo_unitario: 18000.00, cantidad: 1, valor_parcial: 18000.00 }
    ],
    transportes: [
      { id: 'tr-1', descripcion: 'Camioneta 4x4 cuadrilla', volumen_o_peso: 1, rendimiento: 0.05, costo_tarifa: 130500, valor_parcial: 6525.00 }
    ],
    mano_obra: [
      { id: 'mo-1', cargo: 'Técnico Liniero', salario_base: 195000.00, costo_dia: 195000.00, rendimiento: 0.125, horas_hombre: 1.00, costo_total: 24375.00 },
      { id: 'mo-2', cargo: 'Ayudante de Liniería', salario_base: 116532.00, costo_dia: 116532.00, rendimiento: 0.125, horas_hombre: 1.00, costo_total: 14566.50 }
    ],
    aiu: {
      porcentaje_admin: 10.00,
      porcentaje_imprevistos: 0.00,
      porcentaje_utilidad: 3.00,
      porcentaje_iva_utilidad: 19.00
    },
    activo: true,
    created_at: new Date().toISOString(),
  })
]

